// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"vacancies-list_wrapper__pBRYU","title":"vacancies-list_title__yCeWM","titleButton":"vacancies-list_titleButton__2hy7j","line":"vacancies-list_line__DaHvB"};